import React from 'react';
import { compose } from 'ramda';

import styleFile from './AvailFilters.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { RichText, Button } from '@synergycms_core/components/generic/';
import TooltipWrapper from '@synergycms_core/components/generic/TooltipWrapper';
import { connect } from 'react-redux';
import { List, Map, OrderedMap } from 'immutable';
import actions from '../../../store/actions';
import moment from 'moment/moment';
import { parsePenalty } from '../../../utils/penalties';
import { PROPERTY_MANAGEMENT_GROUP } from '../../../config/constants';


const getBoardText = (avail,boards,boardId) => {
  var result = null;
  boards && boards.forEach((board) => {
    if(
      (!isNaN(boardId) && board.get('id').toString() === boardId) ||
      (isNaN(boardId) && board.get('acronym') === boardId)
    ) {
      result = {
        name: board.get('custom_name_web') || board.get('name'),
        desc: board.get('description') || ''
      }
    }
  })
  return result;
}


const AvailFilters = class AvailFilters extends React.Component {
  static displayName = 'AvailFilters';
  


  render() {
    const { classes } = this.props.theme.styles;
    const { 
      filters, 
      
      selection, 
      avail, 
      boards,
      policies,
      segment,
      
      removeFilter, 
      cleanFilters 
    } = this.props.config;
    
    if(!filters) return null;
    
    const boardText = getBoardText(avail,boards,filters.get('board'));
    const refundabilityText = policies[filters.get('type')]
    
    let showCloseFilters = boardText?.name || refundabilityText?.name || filters.get('room');
    
    return (
      <div className={classes.defaultStyle}>
        <div className={classes.content}>
          <div className={classes.containerFiltersActive}>
            {boardText && boardText.name && (
              <>
                {boardText.desc ? (
                  <div className={classes.activeFilter}>
                    <TooltipWrapper
                      popover={boardText.desc && (
                        <span className={[classes.popoverStyle].join(' ')}>
                          <RichText text={boardText.desc} ucFirst={true} innerStyle={[]} translate={true} withVars={boardText.variables || null} />
                        </span>
                      )}
                      popoverStyle={classes.tooltipStyle}
                      pointerStyle={classes.tooltipPointerStyle}
                      bottomLimit={100}
                      posX={'middle'}
                      posY={'bottom'}
                      typeTooltip={'boardFilter'}
                    >
                      <RichText text={boardText.name} ucFirst={true} innerStyle={[classes.filterName]} translate={true} />
                    </TooltipWrapper>
                    <Button
                        innerStyle={[classes.closeButton]}
                        translate={true}
                        icon={{ unicodeContent: 'e001' }}
                        onClick={() => {
                          removeFilter(selection, 'board', filters.get('board'), segment);
                        }}
                    />
                  </div>
                ) : (
                  <div className={classes.activeFilter}>
                    <RichText text={boardText.name} ucFirst={true} innerStyle={[classes.filterName]} translate={true}/>
                    <Button
                      innerStyle={[classes.closeButton]}
                      translate={true}
                      icon={{ unicodeContent: 'e001' }}
                      onClick={() => {
                        removeFilter(selection,'board',filters.get('board'),segment);
                      }}
                    />
                  </div>
                )}
              </>
            )}

            {refundabilityText && refundabilityText.name && (
              <>
                {refundabilityText.desc ? (
                  <div className={classes.activeFilter}>
                    <TooltipWrapper
                      popover={
                        <span className={[classes.popoverStyle].join(' ')}>
                          <RichText text={refundabilityText.desc} ucFirst={true} translate={true} withVars={refundabilityText.variables || null} />
                        </span>
                      }
                      popoverStyle={classes.tooltipStyle}
                      pointerStyle={classes.tooltipPointerStyle}
                      bottomLimit={100}
                      posX={'middle'}
                      posY={'bottom'}
                      typeTooltip={'refundabilityFilter'}>
                      <RichText text={refundabilityText.name} ucFirst={true} innerStyle={[classes.filterName]} translate={true}/>
                    </TooltipWrapper>
                    <Button
                          innerStyle={[classes.closeButton]}
                          translate={true}
                          icon={{ unicodeContent: 'e001' }}
                          onClick={() => {
                            removeFilter(selection,'type',filters.get('type'),segment);
                          }}
                        />
                  </div>
                ) : (
                  <div className={classes.activeFilter}>
                    <RichText text={refundabilityText.name} ucFirst={true} innerStyle={[classes.filterName]} translate={true}/>
                    <Button
                      innerStyle={[classes.closeButton]}
                      translate={true}
                      icon={{ unicodeContent: 'e001' }}
                      onClick={() => {
                        removeFilter(selection,'type',filters.get('type'),segment);
                      }}
                    />
                  </div>
                )}
              </>
            )}
          </div>
          
          
          {showCloseFilters && (
            <div className={classes.clearFilters}>
              <Button
                innerStyle={[classes.clearFiltersBtn]}
                ariaLabel={'_%ver todas las opciones%_'}
                translate={true}
                onClick={() => {
                  cleanFilters(selection,segment);
                }}
              >
                <RichText
                  innerStyle={['roboto13Gray']}
                  text={'_%ver todas las opciones%_'}
                  translate={true}
                  ucFirst={true}
                />
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {
    removeFilter: (selection,type,id,segment) => {
      const newSelection = selection?.map((entry, key) =>
        key === segment - 1 && entry.get(type) === id ? entry.delete(type) || Map() : entry
      ) || Map();
      dispatch(actions.customer.params.updateParams(Map({selection_avail: newSelection})));
      dispatch(actions.router.update());
    },
    cleanFilters: (selection,segment) => {
      const newSelection = selection?.map((entry, key) =>
        key === segment - 1 ? Map() : entry
      ) || Map()
      dispatch(actions.customer.params.updateParams(Map({selection_avail: newSelection})));
      dispatch(actions.router.update());
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const selection = store.getIn(['customer', 'params','params','selection_avail'],null);
  
  if(!selection || selection.size === 0) {
    return { selection: null, filters: null, boards: null, policies: null, segment:null }
  }
  
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const boards = store.getIn(['hotels', hotelId,'boards'],null);
  const filters = selection.get(ownProps.segment-1)
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const queryParams = store.getIn(['hotels', hotelId, 'params', 'query_params']);
  
  const policies = []
  ownProps.avail && ownProps.avail.forEach(room =>
    room?.get('boards')?.forEach(ref =>
      ref?.forEach((board, index) => {
        const days = board.get('days', OrderedMap());
        const flexibleRate = days.first().get('flexible', false) || days.some(day => day.get('discounts').some(d => d.get('flexible', false)));
        const rateSecureCancellation = days && days?.first()?.get('secure_cancellation', false);
        const discountSecureCancellation = board && board?.get('discounts')?.some(d => d?.get('secure_cancellation', false));
        const pmsName = hotelInfo && hotelInfo.get('pms');
        const pms = ((rateSecureCancellation || discountSecureCancellation) && pmsName === 'FlexMyRoom') ? 'FlexMyRoom' : false;

        const penaltyObj = parsePenalty(
          board.getIn(['policies', 'penalties', 0], Map),
          moment(queryParams.get('date')),
          board.get('price_tax'),
          queryParams.get('stay_length'),
          board.getIn(['policies', 'nr']) !== true,
          board.get('discounts', List()),
          days.first(),
          hotelInfo.get('management_group_id') === PROPERTY_MANAGEMENT_GROUP,
          false,
          pms,
          null,
          hotelInfo.get('management_group_id'),
        );

        let rateName = '';
        if (pms === 'FlexMyRoom') {
          rateName = '_%cancelación segura%_';
        } 
        else {
          if (penaltyObj.nr !== true && !penaltyObj.applyPenaltyRelease && !flexibleRate) {
            rateName = '_%cancelación gratuita%_';
          } else if (penaltyObj.nr === true && board.get('discount_percent') <= -5 && !flexibleRate) {
            rateName = '_%tarifa de oferta%_';
          } else {
            rateName = '_%condiciones especiales%_';
          }
        }

        policies[index] = {
          name: rateName || ',',
          desc: penaltyObj.text || board.getIn(['policies', 'description']) || '',
          variables: penaltyObj,
        };
      })
    )
  );
  
  return {
    selection: selection,
    filters: filters,
    boards: boards,
    policies: policies,
    segment: ownProps.segment,
  }
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  PropertyManager([
    'avail',
    'selection',
    'filters',
    'boards',
    'policies',
    'segment',
    
    'removeFilter',
    'cleanFilters'
  ]),
  withThemeJSS({ styleFile, link: true })
)(AvailFilters);